import React, { useState, useEffect } from "react";
import { EditCharge } from "../../pages";
import { ChargeController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import * as yup from "yup";

const EditChargeContainer = ({ closeModal, data }) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = () => {
        return (
            yup.object().shape({
                name: yup.string().required("Enter Charge Name"),
                value: yup.string().required("Enter Value"),
            })
        )
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            type: values.type,
            value: values.value,
            businesses: values.businesses,
        }
        const { status, errorMessage } = await ChargeController.editCharge(payload, data._id);
        if (status === constant.Success) {
            closeModal();
            setLoading(false);
            MimaToastUtil.success({
                message: constant.Success,
            });
        }
        setLoading(false);
        ChargeController.getCharges()
        return closeModal();
    };

    const currencyCodes = [
        {
            key: "NGN", value: "NGN"
        },
        {
            key: "USD", value: "USD"
        },
        {
            key: "GBP", value: "GBP"
        },
        {
            key: "EUR", value: "EUR"
        }
    ]

    return (
        <EditCharge
            closeModal={closeModal}
            currencyCodes={currencyCodes}
            loading={loading}
            onSubmit={onSubmit}
            data={data}
            validationSchema={validationSchema}
        />
    )
}
export default EditChargeContainer;